import Pizza from "../../scenarios/assets/pizza.svg";
import Pizza2 from "../../scenarios/assets/pizza2.svg";

export default {
  routes: {
    user: {
      // Redis New Look Video
      videoId: "jbJHu3CjHi0"
    }
  },
  enableEUCookieBanner: true,
  rules: [
    {
      url: "https://www.fooji.com",
      description: "Visit Fooji"
    },
    {
      url: "https://www.fooji.com",
      description: "See Magic"
    }
  ],
  vote_options: [
    {
      label: "Horses",
      id: "horses_key",
      image: "https://www.clipartmax.com/png/middle/91-912982_little-horse-emoji-horse-emoji.png"
    }
  ],
  custom_fields: [
    {
      identifier: "3d080366-d00d-4d32-b0f0-9526c7879a6a",
      is_required: true,
      name: "birthdate",
      type: "date_input",
      validation: "dob",
      validation_config: "18"
    },
    {
      identifier: "3d080366-d00d-4d32-b0f0-9526c7879a6b",
      is_required: true,
      name: "tax_id",
      type: "text"
    }
  ],
  channels: ["anonymous", "twitter"],
  languages: ["en", "es"],
  entry_gate: [
    {
      name: "age",
      label: "Age",
      type: "number",
      maxLength: 3
    },
    {
      name: "name",
      label: "Name",
      type: "text"
    },
    {
      name: "email",
      label: "E-Mail",
      type: "email",
      maxLength: 100
    }
  ],
  follow_up_survey: [
    {
      question: "Where did you hear about our service?",
      is_required: true,
      options: [],
      id: "follow-up-survey-question-169f5f13-a6dc-48b7-936a-d12e83ed8ad0",
      type: "text"
    },
    {
      question: "Where did you hear about our service?",
      is_required: true,
      options: ["Internet", "Offline"],
      id: "follow-up-survey-question-169f5f13-a6dc-48b7-936a-d12e83ed8ad4",
      type: "choice"
    },
    {
      question: "What sports do you play?",
      is_required: true,
      options: ["Football", "Tennis", "Racing", "Running"],
      id: "follow-up-survey-question-169f5f13-a6dc-48b7-936a-d12e83ed8ad9",
      type: "multiple-choice"
    },
    {
      question: "Do you love Fooji?",
      is_required: true,
      options: ["Yes", "No"],
      id: "follow-up-survey-question-169f5f13-a6dc-48b7-936a-d12e83ed8ad6",
      type: "choice"
    },
    {
      question: "What is your age range",
      is_required: false,
      options: ["Younger than 18 years of age", "Older than 18 years of age"],
      id: "follow-up-survey-question-169f5f13-a6dc-48b7-936a-d12e83ed8ad5",
      type: "choice"
    }
  ],
  survey_questions: [
    {
      question: "Where did you hear about our service?",
      is_required: true,
      options: [],
      id: "survey-question-169f5f13-a6dc-48b7-936a-d12e83ed8ad0",
      type: "text"
    },
    {
      question: "Where did you hear about our service?",
      is_required: true,
      options: ["Internet", "Offline"],
      id: "survey-question-169f5f13-a6dc-48b7-936a-d12e83ed8ad4",
      type: "choice"
    },
    {
      question: "What sports do you play?",
      is_required: true,
      options: ["Football", "Tennis", "Racing", "Running"],
      id: "survey-question-169f5f13-a6dc-48b7-936a-d12e83ed8ad9",
      type: "multiple-choice"
    },
    {
      question: "Do you love Fooji?",
      is_required: true,
      options: ["Yes", "No"],
      id: "survey-question-169f5f13-a6dc-48b7-936a-d12e83ed8ad6",
      type: "choice"
    },
    {
      question: "What is your age range",
      is_required: false,
      options: ["Younger than 18 years of age", "Older than 18 years of age"],
      id: "survey-question-169f5f13-a6dc-48b7-936a-d12e83ed8ad5",
      type: "choice"
    }
  ],
  skillTest: {
    question: "0 + 30 * 21 + 22",
    answer: 652,
    countries: [
      "ca",
      "world",
      "gb"
    ]
  },
  countries: ["US", "CA"],
  deliveryZones: [
    [
      [
        -108.97770702838899,
        48.96836113437751,
        0
      ],
      [
        -115.90576171875001,
        48.96954790281772,
        0
      ],
      [
        -119.36468482017519,
        48.969847231643044,
        0
      ],
      [
        -122.64268755912782,
        48.972970708755156,
        0
      ],
      [
        -122.61773228645326,
        48.736482662576364,
        0
      ],
      [
        -122.86981232464316,
        48.25342797596037,
        0
      ],
      [
        -122.02020968485161,
        47.636372339330116,
        0
      ],
      [
        -122.0187796378741,
        47.63674665435032,
        0
      ],
      [
        -122.01711689878722,
        47.63567441531269,
        0
      ],
      [
        -122.0181741200213,
        47.63497733007939,
        0
      ],
      [
        -121.73567961799566,
        47.483951856274096,
        0
      ],
      [
        -121.7336687522766,
        47.48131997336011,
        0
      ],
      [
        -121.732534722687,
        47.48155824664881,
        0
      ],
      [
        -121.73302883194994,
        47.482132223087625,
        0
      ],
      [
        -121.73412448028105,
        47.48194056631625,
        0
      ],
      [
        -121.73569730119199,
        47.48394647171553,
        0
      ],
      [
        -121.87691017788894,
        47.55951386582001,
        0
      ],
      [
        -122.01806614932141,
        47.63479428885422,
        0
      ],
      [
        -122.86973319947721,
        48.253580671386274,
        0
      ],
      [
        -125.45270919799806,
        48.529537097228854,
        0
      ],
      [
        -125.4866123199463,
        42.282071538107985,
        0
      ],
      [
        -128.28941345214847,
        41.696436423641416,
        0
      ],
      [
        -134.21752452850345,
        53.996544215669594,
        0
      ],
      [
        -131.0008478164673,
        54.55198088707615,
        0
      ],
      [
        -130.90008258819583,
        55.75312941730941,
        0
      ],
      [
        -135.56365013122561,
        59.47553918924642,
        0
      ],
      [
        -137.61341571807864,
        58.74803428965331,
        0
      ],
      [
        -137.83597469329837,
        59.16388661461256,
        0
      ],
      [
        -139.70047473907474,
        60.02542294197144,
        0
      ],
      [
        -141.02522850036624,
        59.71335251065009,
        0
      ],
      [
        -141.53926849365237,
        61.09191098888713,
        0
      ],
      [
        -141.6904163360596,
        71.67464951059355,
        0
      ],
      [
        -151.06862068176272,
        71.76188377933447,
        0
      ],
      [
        -163.93052101135257,
        71.27485428091133,
        0
      ],
      [
        -167.33430862426758,
        68.28485755650013,
        0
      ],
      [
        -170.25692939758304,
        61.495017341251184,
        0
      ],
      [
        -169.5696830749512,
        48.104737442527814,
        0
      ],
      [
        -159.34819221496585,
        26.559510623079564,
        0
      ],
      [
        -163.50059509277347,
        21.655513665155286,
        0
      ],
      [
        -154.08402442932132,
        17.289839822795113,
        0
      ],
      [
        -152.62610435485843,
        19.68259637233462,
        0
      ],
      [
        -157.99678802490237,
        23.892272870230947,
        0
      ],
      [
        -125.40593147277833,
        41.009892254964996,
        0
      ],
      [
        -122.29521274566652,
        33.646313991000326,
        0
      ],
      [
        -117.34763145446779,
        32.52669729674311,
        0
      ],
      [
        -114.972642660141,
        32.71427611057757,
        0
      ],
      [
        -114.73261713981628,
        32.71563917516089,
        0
      ],
      [
        -114.81576561927797,
        32.505672115827814,
        0
      ],
      [
        -113.7153625488281,
        32.16100889847316,
        0
      ],
      [
        -111.09044551849367,
        31.337326941761116,
        0
      ],
      [
        -108.25957775115967,
        31.344914192293793,
        0
      ],
      [
        -108.1991958618164,
        31.815146465354484,
        0
      ],
      [
        -106.36602401733398,
        31.752820804797622,
        0
      ],
      [
        -106.20255947113039,
        31.499366482241946,
        0
      ],
      [
        -105.8067297935486,
        31.254890750916683,
        0
      ],
      [
        -105.46014547348022,
        30.90933133728827,
        0
      ],
      [
        -104.96893644332887,
        30.65162853610506,
        0
      ],
      [
        -104.66421604156496,
        30.17944916992578,
        0
      ],
      [
        -104.68762636184694,
        29.951309175755064,
        0
      ],
      [
        -104.48379993438722,
        29.6341843999251,
        0
      ],
      [
        -104.06857252120973,
        29.3678143847754,
        0
      ],
      [
        -103.70585203170776,
        29.23016336273236,
        0
      ],
      [
        -103.37379455566408,
        29.064084893229385,
        0
      ],
      [
        -103.17994594573975,
        29.01928666156212,
        0
      ],
      [
        -103.11076641082765,
        29.112913047517168,
        0
      ],
      [
        -102.8894090652466,
        29.23317810164186,
        0
      ],
      [
        -102.75321722030641,
        29.602957770689265,
        0
      ],
      [
        -102.62676715850831,
        29.76743213249377,
        0
      ],
      [
        -102.30887174606323,
        29.88921111749995,
        0
      ],
      [
        -101.88686370849611,
        29.84287739372952,
        0
      ],
      [
        -101.46442651748657,
        29.81808281215006,
        0
      ],
      [
        -100.82305669784547,
        29.26244079669894,
        0
      ],
      [
        -100.4846879420802,
        28.686914895326684,
        0
      ],
      [
        -99.96821338310839,
        28.924095813332528,
        0
      ],
      [
        -99.44897267036141,
        29.161675280114302,
        0
      ],
      [
        -98.414128898512,
        29.63452365359074,
        0
      ],
      [
        -98.41401556011989,
        29.63550818264647,
        0
      ],
      [
        -98.41304773974119,
        29.635484058111196,
        0
      ],
      [
        -98.41309631679907,
        29.63464065480658,
        0
      ],
      [
        -98.41412929730723,
        29.634524747273474,
        0
      ],
      [
        -100.48461138387212,
        28.686898240614376,
        0
      ],
      [
        -100.02493858337404,
        28.07684605723587,
        0
      ],
      [
        -99.50892448425294,
        27.581709456471227,
        0
      ],
      [
        -99.40489768981935,
        27.044697665094485,
        0
      ],
      [
        -99.05833482742311,
        26.427019971387484,
        0
      ],
      [
        -98.230197429657,
        26.093056010317138,
        0
      ],
      [
        -97.76684045791627,
        25.96476564915943,
        0
      ],
      [
        -97.62468338012695,
        25.866845568887786,
        0
      ],
      [
        -97.45842397212982,
        25.79765984398922,
        0
      ],
      [
        -97.35863775014879,
        25.81476569577889,
        0
      ],
      [
        -97.28393822908403,
        25.85159139398317,
        0
      ],
      [
        -97.30823770165445,
        25.92909813193143,
        0
      ],
      [
        -97.17005968093873,
        25.9864982753877,
        0
      ],
      [
        -91.12687110900879,
        28.567826165324988,
        0
      ],
      [
        -87.61384248733522,
        30.369866832318003,
        0
      ],
      [
        -87.30186939239503,
        30.156821191148392,
        0
      ],
      [
        -86.9903415441513,
        30.2620326285407,
        0
      ],
      [
        -86.94910526275636,
        29.56117656904328,
        0
      ],
      [
        -85.98723292350769,
        29.677016656227455,
        0
      ],
      [
        -84.0773391723633,
        27.794059915568383,
        0
      ],
      [
        -82.0733964443207,
        24.080428260613765,
        0
      ],
      [
        -79.79128718376161,
        24.87357906291087,
        0
      ],
      [
        -79.5637607574463,
        28.231356128133015,
        0
      ],
      [
        -76.84648990631105,
        26.87047783368133,
        0
      ],
      [
        -73.19576740264894,
        24.37606542197341,
        0
      ],
      [
        -67.48350977897645,
        19.636747025584597,
        0
      ],
      [
        -67.23332405090333,
        17.84727503528203,
        0
      ],
      [
        -65.73102951049806,
        17.826971366780974,
        0
      ],
      [
        -65.37078738212587,
        18.64753617995198,
        0
      ],
      [
        -80.8113017678261,
        29.86539799175068,
        0
      ],
      [
        -81.32431648671628,
        30.63293919848419,
        0
      ],
      [
        -81.22672498226167,
        30.738707370906287,
        0
      ],
      [
        -74.47959870100023,
        34.532048587709404,
        0
      ],
      [
        -77.56253368221225,
        34.76805186970141,
        0
      ],
      [
        -80.65031053265558,
        35.00017483479862,
        0
      ],
      [
        -80.65361344910346,
        34.99946216265188,
        0
      ],
      [
        -80.65314966661391,
        35.00109915605728,
        0
      ],
      [
        -80.65154434356373,
        35.00099101602904,
        0
      ],
      [
        -80.65028716810049,
        35.0001725808069,
        0
      ],
      [
        -74.4752883911133,
        34.53502849470945,
        0
      ],
      [
        -71.654089987278,
        38.27867908056549,
        0
      ],
      [
        -77.4096123299387,
        39.04180931996713,
        0
      ],
      [
        -77.40954916640477,
        39.04209763631511,
        0
      ],
      [
        -77.40975111068111,
        39.04255768203514,
        0
      ],
      [
        -77.41071129828926,
        39.0424117617009,
        0
      ],
      [
        -77.41066324935673,
        39.0420989860769,
        0
      ],
      [
        -77.41055583755953,
        39.04187945264946,
        0
      ],
      [
        -77.41034295522697,
        39.04152732121767,
        0
      ],
      [
        -77.40945383731743,
        39.04173226652732,
        0
      ],
      [
        -77.40961089322809,
        39.041808714730216,
        0
      ],
      [
        -74.53202452976258,
        38.661031217887505,
        0
      ],
      [
        -71.62638813257219,
        38.2565405572776,
        0
      ],
      [
        -72.88197147427127,
        39.62757585267758,
        0
      ],
      [
        -74.11440311538172,
        40.94340717655672,
        0
      ],
      [
        -74.11520147463307,
        40.94563818568888,
        0
      ],
      [
        -74.11613413882152,
        40.946337301541384,
        0
      ],
      [
        -74.11520120615025,
        40.94638212338302,
        0
      ],
      [
        -74.11518278298901,
        40.94563345070549,
        0
      ],
      [
        -74.11441475836911,
        40.9434233887194,
        0
      ],
      [
        -71.64927139878274,
        38.286241305650144,
        0
      ],
      [
        -69.11085695028306,
        41.555786032744614,
        0
      ],
      [
        -66.66693806648256,
        44.67117840640356,
        0
      ],
      [
        -67.21981644630434,
        45.187511672659014,
        0
      ],
      [
        -67.36174821853639,
        45.11630531101468,
        0
      ],
      [
        -67.50532150268556,
        45.29286001681622,
        0
      ],
      [
        -67.42029547691347,
        45.378640955674335,
        0
      ],
      [
        -67.52154350280763,
        45.485996558648615,
        0
      ],
      [
        -67.42328882217409,
        45.521743896993634,
        0
      ],
      [
        -67.46329665184022,
        45.5997616648782,
        0
      ],
      [
        -67.6776695251465,
        45.619875760142214,
        0
      ],
      [
        -67.81718730926515,
        45.81384543769449,
        0
      ],
      [
        -67.80186653137208,
        46.336380436878144,
        0
      ],
      [
        -67.78796195983888,
        46.912369847609384,
        0
      ],
      [
        -67.83109188079835,
        47.090637165667175,
        0
      ],
      [
        -68.31182956695558,
        47.349320281432185,
        0
      ],
      [
        -68.7636423110962,
        47.19493258357909,
        0
      ],
      [
        -69.0703582763672,
        47.24136611051448,
        0
      ],
      [
        -69.2285442352295,
        47.434067694363506,
        0
      ],
      [
        -69.86206054687501,
        46.78140147347959,
        0
      ],
      [
        -70.20915985107423,
        46.20683422158184,
        0
      ],
      [
        -70.2664089202881,
        45.87770006220794,
        0
      ],
      [
        -70.52463054656984,
        45.63189574120618,
        0
      ],
      [
        -70.68457603454591,
        45.52855391937701,
        0
      ],
      [
        -70.61629772186281,
        45.374006044386896,
        0
      ],
      [
        -70.77549219131471,
        45.400333317830125,
        0
      ],
      [
        -70.85297584533693,
        45.209526688323834,
        0
      ],
      [
        -70.97803115844728,
        45.31612436059544,
        0
      ],
      [
        -71.18104219436647,
        45.2174778207308,
        0
      ],
      [
        -71.31017446517946,
        45.310963714983856,
        0
      ],
      [
        -71.5564012527466,
        44.98176910169989,
        0
      ],
      [
        -73.85280132293703,
        44.98034238084973,
        0
      ],
      [
        -74.92044925689699,
        44.98489562110823,
        0
      ],
      [
        -75.72092771530153,
        44.494261102610274,
        0
      ],
      [
        -75.88826805353166,
        44.34926359035273,
        0
      ],
      [
        -76.43739938735963,
        43.99989783516596,
        0
      ],
      [
        -76.78159117698671,
        43.60841035545684,
        0
      ],
      [
        -77.439022064209,
        43.59322891801368,
        0
      ],
      [
        -78.68887379765512,
        43.61258768632962,
        0
      ],
      [
        -79.10012349486351,
        43.447722774836755,
        0
      ],
      [
        -79.06945444643499,
        43.080205449955734,
        0
      ],
      [
        -79.00652378797533,
        43.061309160994796,
        0
      ],
      [
        -79.02823828160764,
        43.00641735163228,
        0
      ],
      [
        -79.00231875479223,
        42.96963574767908,
        0
      ],
      [
        -78.9228442311287,
        42.9492948118759,
        0
      ],
      [
        -78.90519060194492,
        42.915266505492845,
        0
      ],
      [
        -78.90404261648655,
        42.882177539194586,
        0
      ],
      [
        -78.90423640608789,
        42.83891766538486,
        0
      ],
      [
        -79.38659816980362,
        42.54214496439095,
        0
      ],
      [
        -80.15923529863358,
        42.33699588786946,
        0
      ],
      [
        -80.96623420715333,
        42.21472440059244,
        0
      ],
      [
        -81.98511958122253,
        41.658252669087474,
        0
      ],
      [
        -82.7070200443268,
        41.62156212064864,
        0
      ],
      [
        -83.01857471466066,
        41.72949734001022,
        0
      ],
      [
        -83.15701961517335,
        42.00085037004406,
        0
      ],
      [
        -83.14469486474992,
        42.11746064973031,
        0
      ],
      [
        -83.12663018703462,
        42.28553225400903,
        0
      ],
      [
        -83.04948985576631,
        42.33904396211545,
        0
      ],
      [
        -82.93120846152307,
        42.36047534649302,
        0
      ],
      [
        -82.83908665180208,
        42.387849864494946,
        0
      ],
      [
        -82.6428709924221,
        42.55526751914483,
        0
      ],
      [
        -82.59241193532944,
        42.54954736502162,
        0
      ],
      [
        -82.51714244484901,
        42.620657327945565,
        0
      ],
      [
        -82.48151868581773,
        42.72022041679028,
        0
      ],
      [
        -82.46749341487886,
        42.76597848003395,
        0
      ],
      [
        -82.47631788253786,
        42.82059785009647,
        0
      ],
      [
        -82.46036477386951,
        42.91261850938428,
        0
      ],
      [
        -82.41216480731966,
        42.971000238985006,
        0
      ],
      [
        -82.4273903667927,
        42.997398975795896,
        0
      ],
      [
        -82.39502683281898,
        43.04503769777394,
        0
      ],
      [
        -82.27571547031404,
        43.25380663655242,
        0
      ],
      [
        -82.16085791587831,
        43.59765011063929,
        0
      ],
      [
        -82.25326538085939,
        43.85993680716246,
        0
      ],
      [
        -82.55560398101808,
        45.204235394920154,
        0
      ],
      [
        -83.64050388336183,
        45.74819559453815,
        0
      ],
      [
        -84.39071774482728,
        46.37718758796992,
        0
      ],
      [
        -84.66949045658113,
        46.4958257500658,
        0
      ],
      [
        -85.91265678405763,
        47.23489758669495,
        0
      ],
      [
        -87.5192302465439,
        47.864298899465695,
        0
      ],
      [
        -89.176025390625,
        47.96567496073642,
        0
      ],
      [
        -89.80603873729707,
        47.90796787807232,
        0
      ],
      [
        -90.61023473739625,
        48.06602433657652,
        0
      ],
      [
        -91.33592784404756,
        48.0164392302453,
        0
      ],
      [
        -92.4124002456665,
        48.22352900913935,
        0
      ],
      [
        -92.80333220958711,
        48.46262424905265,
        0
      ],
      [
        -93.15052270889282,
        48.574012603114376,
        0
      ],
      [
        -93.3587694168091,
        48.48432558782143,
        0
      ],
      [
        -93.84574055671693,
        48.48669360870963,
        0
      ],
      [
        -93.92315447330476,
        48.5877610238702,
        0
      ],
      [
        -94.51440989971161,
        48.66053263236594,
        0
      ],
      [
        -94.8002851009369,
        48.80586361152725,
        0
      ],
      [
        -94.8358190059662,
        49.05274487054388,
        0
      ],
      [
        -95.11590063571931,
        48.98305464727572,
        0
      ]
    ]
  ],
  menus: {
    dummy:  [
      {
        visible_name: "High 5",
        visible_variation: "DEFAULT",
        name: "high-5",
        description: "A high five. Great for congratulating someone.",
        image: Pizza,
        emoji: null,
        variation: "default"
      },
      {
        visible_name: "Handshake",
        visible_variation: "ONE",
        visible_variation_2: "FOO",
        name: "handshake",
        description: "Very nice handshake. Great for making friends.",
        image: Pizza2,
        emoji: null,
        variation: "one|foo"
      },
      {
        visible_name: "Handshake",
        visible_variation: "ONE",
        visible_variation_2: "BAR",
        name: "handshake",
        description: "Very nice handshake. Great for making friends.",
        image: Pizza2,
        emoji: null,
        variation: "one|bar"
      },
      {
        visible_name: "Handshake",
        visible_variation: "WET",
        visible_variation_2: "BAR",
        name: "handshake",
        description: "Very wet handshake. Great for making enemies for life.",
        image: Pizza2,
        emoji: null,
        variation: "wet|bar"
      },
      {
        visible_name: "Handshake",
        visible_variation: "WET",
        visible_variation_2: "FOO",
        name: "handshake",
        description: "Very wet handshake. Great for making enemies for life.",
        image: Pizza2,
        emoji: null,
        variation: "wet|foo"
      },
      {
        visible_name: "Fist Bump",
        visible_variation: "DEFAULT",
        name: "fist-bump",
        description: "A fist bump. Great for showing respect.",
        image: Pizza,
        emoji: null,
        variation: "default"
      },
      {
        visible_name: "Fist Bump",
        visible_variation: "SLOW",
        name: "fist-bump",
        description: "A slow fist bump. Great for showing respect.",
        image: Pizza,
        emoji: null,
        variation: "slow"
      }
    ]
  }
};
